export default __webpack_public_path__ + "static/media/calstart-logo2.4117471f.png";